import { Address } from "./address";
import { Customer } from "./customer";
import { Equipment } from "./equipment";
import EquipmentType from "./equipmentType";
import { Note } from "./note";
import { Transaction } from "./transaction";

export class Invoice {
  invoice_id = -1;
  appointment_id = -1;
  job_id = -1;
  quote_type = "";
  summary?: string;
  format?: string;
  customer = new Customer();
  billing_customer = new Customer();
  service_address?: Address;
  billing_address?: Address;
  links?: {
    invoice_approve: string;
    invoice_email: string;
    invoice_pdf: string;
    payment_create: string;
    payment_list: string;
    payment_receivers: string;
    equipment_link_create: string;
  } = undefined;
  signature?: {
    kind: string;
    image_url: string;
    signature_time: string;
  } = undefined;
  items_attributes: InvoiceLineItem[] = [];
  financials = {
    subtotal_cents: -1,
    discount_amount_cents: 0,
    refundable_amount_cents: 0,
    late_fee_cents: 0,
    sales_tax_cents: 0,
    total_cents: 0,
    total_transactions_cents: 0,
    balance_cents: 0,
    savings_cents: undefined as number | undefined
  };
  notes: Note[] = [];
  finalized: false;
  voided: false;
  invoice_date = ""; // Date
  next_payment_key = "";
  payments: Transaction[] = [];
  payment_create_url?: string;
  payment_list_url?: string;
  payment_receivers_url?: string;
  exclude_from_batching: boolean;
  qbo_sync_status?: string;
  qbo_id?: string;
  qbo_url?: string;
  constructor(params: Partial<Invoice> = {}) {
    Object.assign(this, params);
  }
}

export class InvoiceLineItem {
  id = -1;
  item_id = -1;
  item_type = "";
  unit_name = "";
  description = "";
  warranty = "";
  quantity = 0;
  unit_price_cents = 0;
  total_cents = 0;
  comparison_price_cents?: number = undefined;
  comparison_total_cents = 0;
  covered_systems = 0;
  type = "";
  invoice_format?: string;
  equipment_request_status = "";
  equipment_links: EquipmentLink[] = [];
  links?: {
    time_override: string;
    pricebook_link: string;
    equipment_link_create: string;
  } = undefined;
  items_in_group?: InvoiceLineItem[] = [];

  constructor(params: Partial<InvoiceLineItem> = {}) {
    Object.assign(this, params);
  }
}

export class EquipmentLink {
  id = -1;
  invoice_line_item_id = -1;
  equipment_type = new EquipmentType();
  equipment?: Equipment = undefined;
  not_applicable = false;
  status = "";
  optional = false;
  links?: {
    equipment_link_update: string;
    equipment_link_destroy: string;
  } = undefined;

  constructor(params: Partial<EquipmentLink> = {}) {
    Object.assign(this, params);
  }
}

export enum EquipmentRequestStatus {
  FULFILLED = "fulfilled",
  UNFULFILLED = "unfulfilled",
  OPTIONAL = "optional"
}
